import { InjectionToken } from '@angular/core';

export const INTERNAL_API_BASE_URL = new InjectionToken<string>('INTERNAL_API_BASE_URL');